import React from 'react';

class FontAwesome extends React.Component {
  render () {
    return (
      <div>
        <h2>Font Awesome</h2>
        <p className="mb-5">FontAwesome icons are imported with the help of the the <code>react-fontawesome</code> npm package. To see how to install it and use the icons inside your project, please check out their detailed documentation <a href="https://www.npmjs.com/package/@fortawesome/react-fontawesome" target="_blank" rel="noopener noreferrer">here</a>.</p>
      </div>
    )
  }

};

export default FontAwesome;
